module.exports = __webpack_public_path__ + "media/images/covid/icons/temperature-bc3a4dc895a4fb76681a5a8ac62696b1.svg";